import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import EventsSection from "./components/EventsSection";
import GallerySection from "./components/GallerySection";
import MembershipSection from "./components/MembershipSection";
import ContactSection from "./components/ContactSection";
import PayDuesSection from "./components/PayDuesSection";
import ApparelSection from "./components/ApparelSection";
export default function Home() {
  useEffect(() => {
    const siteUrl = (import.meta as Record<string, Record<string, string>>).env?.VITE_SITE_URL ?? "https://example.com";

    const schemas = [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Respect Motorcycle Club",
        "alternateName": ["Respect MC", "Respect Social Club", "Respect Auto Club"],
        "url": siteUrl,
        "logo": `${siteUrl}/favicon.png`,
        "description": "Respect Motorcycle Club — a brotherhood of riders and enthusiasts founded in 2026. Open to all riders and car enthusiasts. Social Club and Auto Club memberships available.",
        "foundingDate": "2026",
        "sameAs": []
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Respect Motorcycle Club",
        "url": siteUrl
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What is Respect Motorcycle Club?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Respect Motorcycle Club is a brotherhood founded in 2026, welcoming riders of all types — cruisers, crotch rockets, trikes, Can-Am 3-wheel motorcycles — as well as a Social Club for non-riders and an Auto Club for car enthusiasts."
            }
          },
          {
            "@type": "Question",
            "name": "How do I join Respect MC?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "You can join by completing the membership application on our website or contacting us directly. Membership options include Motorcycle Club, Social Club, and Auto Club."
            }
          },
          {
            "@type": "Question",
            "name": "What types of memberships are available?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We offer three membership types: Motorcycle Club for riders, Social Club for non-riders who want to be part of the brotherhood, and Auto Club for car enthusiasts."
            }
          }
        ]
      }
    ];

    schemas.forEach((schema, i) => {
      const id = `schema-jsonld-${i}`;
      let script = document.getElementById(id) as HTMLScriptElement | null;
      if (!script) {
        script = document.createElement("script");
        script.id = id;
        script.type = "application/ld+json";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    });

    return () => {
      schemas.forEach((_, i) => {
        const el = document.getElementById(`schema-jsonld-${i}`);
        if (el) el.remove();
      });
    };
  }, []);

  return (
    <div className="bg-[#0d0d0d] min-h-screen">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <EventsSection />
      <GallerySection />
      <MembershipSection />
      <ContactSection />
      <PayDuesSection />
      <ApparelSection />
    </div>
  );
}
